import React from "react";
import { FaRotateRight } from "react-icons/fa6";

const RefreshButton = (params: {
  onRefresh: () => void;
  theme?: "dark" | "light";
}) => {
  return (
    <button
      onClick={params.onRefresh}
      className={`btn btn-link btn-xs flex items-center gap-2 ${
        params.theme == "light" ? "text-white" : ``
      }`}
    >
      Muat ulang <FaRotateRight />
    </button>
  );
};

export default RefreshButton;
